import Vue from 'vue';
import VueRouter from 'vue-router';

import LoginView from '@shared/views/LoginView.vue';
import ImageView from '@shared/views/ImageView.vue';
import LoginWithEmailView from '@shared/views/LoginWithEmailView.vue';
import LoginVerifyView from '@shared/views/LoginVerifyView.vue';
import CreatePasswordView from '@shared/views/CreatePasswordView.vue';
import CreateProPasswordView from '@shared/views/CreateProPasswordView.vue';
import ForgotPasswordView from '@shared/views/ForgotPasswordView.vue';
import ResetPasswordView from '@shared/views/ResetPasswordView.vue';
import ResetProPasswordView from '@shared/views/ResetProPasswordView.vue';
import DownloadProAppView from '@shared/views/DownloadProAppView.vue';
import ProPasswordSuccessView from '@shared/views/ProPasswordSuccessView.vue';
import ExpiredLinkView from '@shared/views/ExpiredLinkView.vue';
import ExpiredLinkResetView from '@shared/views/ExpiredLinkResetView.vue';
import MainView from '@shared/views/MainView.vue';
import AdoptionView from '@shared/views/AdoptionView.vue';
import AdoptionInstallationView from '@shared/views/AdoptionInstallationView.vue';
import TechnicianView from '@shared/views/TechnicianView.vue';
import TechnicianProfileView from '@shared/views/TechnicianProfileView.vue';
import SettingView from '@shared/views/SettingView.vue';
import LeadDetailPdfView from '@shared/views/LeadDetailPdfView.vue';
import MemberOrdersView from '@shared/views/MemberOrdersView.vue';
import SACPageNotFound from '@shared/components/sac/SACPageNotFound.vue';
import ServiceView from '@shared/views/ServiceView.vue';
import SystemHealthView from '@shared/views/SystemHealth.vue';
import CustomerView from '@shared/views/Customer.vue';
import PartnerOrderReviewView from '@shared/views/PartnerOrderReview.vue';
import UserActivitiesView from '@shared/views/UserActivities.vue';
import CustomerDetailView from '@/screens/CustomerDetail.vue';
import ReviewView from '@shared/views/agreement/ReviewView.vue';
import BranchSetupView from '@shared/views/agreement/BranchSetupView.vue';
import PaymentSetupView from '@shared/views/agreement/PaymentSetupView.vue';
import UpdatePaymentView from '@shared/views/agreement/UpdatePaymentView.vue';
import PartnerOrderView from './screens/PartnerOrder.vue';
import RedirectToAppView from '../shared/views/RedirectToAppView.vue';
import SetPasswordView from '../shared/views/SetPasswordView.vue';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/login',
      component: LoginView,
    },
    {
      path: '/login-email',
      component: LoginWithEmailView,
    },
    {
      path: '/resetpassword',
      component: RedirectToAppView,
    },
    {
      path: '/login/verify',
      component: LoginVerifyView,
    },
    {
      path: '/forgot-password',
      component: ForgotPasswordView,
    },
    {
      path: '/reset-password/:token',
      component: ResetPasswordView,
    },
    {
      path: '/reset-password/pro/:token',
      component: ResetProPasswordView,
    },
    {
      path: '/create-password/:token/:email',
      component: CreatePasswordView,
    },
    {
      path: '/create-password/pro/:token',
      component: CreateProPasswordView,
    },
    {
      path: '/pro/success',
      component: ProPasswordSuccessView,
    },
    {
      path: '/download-pro',
      component: DownloadProAppView,
    },
    {
      path: '/expired-link',
      component: ExpiredLinkView,
      name: 'Expired Link',
    },
    {
      path: '/expired-link/reset',
      component: ExpiredLinkResetView,
      name: 'Expired Link Reset',
    },
    {
      path: '/image',
      component: ImageView,
      beforeEnter: (to, from, next) => {
        if (localStorage.currentUser) {
          next();
          return;
        }
        next('/login');
      },
    },
    {
      path: '/',
      component: MainView,
      children: [
        {
          path: '/adoption',
          component: AdoptionView,
          name: 'Adoption',
        },
        {
          path: '/set-password',
          component: SetPasswordView,
          name: 'SetPassword',
        },
        {
          path: '/adoption/installations',
          component: AdoptionInstallationView,
          name: 'AdoptionInstallation',
        },
        {
          path: '/technician',
          component: TechnicianView,
          name: 'Technician',
        },
        {
          path: '/agreement/:agreementId',
          component: ReviewView,
          name: 'ReviewView',
        },
        {
          path: '/agreement/:agreementId/payment/update',
          component: UpdatePaymentView,
          name: 'UpdatePaymentView',
        },
        {
          path: '/agreement/:agreementId/setup',
          component: BranchSetupView,
          name: 'BranchSetupView',
        },
        {
          path: '/agreement/:agreementId/payment',
          component: PaymentSetupView,
          name: 'PaymentSetupView',
        },
        {
          path: '/technician/:technicianId',
          component: TechnicianProfileView,
          name: 'TechnicianProfile',
        },
        {
          path: '/lead/pdf/:leadId',
          component: LeadDetailPdfView,
          name: 'LeadDetailPdf',
        },
        {
          path: '/service',
          component: ServiceView,
          name: 'SmartService',
        },
        {
          path: '/systemhealth',
          component: SystemHealthView,
          name: 'System Health',
        },
        {
          path: '/member',
          component: CustomerView,
          name: 'Member',
        },
        {
          path: '/member/:customerId',
          component: CustomerDetailView,
          name: 'CustomerDetail',
        },
        {
          path: '/user-activities',
          component: UserActivitiesView,
          name: 'UserActivities',
        },
        {
          path: '/partner-order',
          component: PartnerOrderView,
          name: 'Partner Order',
        },
        {
          path: '/member-order',
          component: MemberOrdersView,
          name: 'Member Order',
        },
        {
          path: '/order/partner/:orderNumber/review',
          component: PartnerOrderReviewView,
          name: 'Partner Order Review',
        },
        {
          path: '/settings',
          component: SettingView,
          name: 'Settings',
        },
      ],
    },
    {
      path: '/not-found',
      component: SACPageNotFound,
      name: 'Not Found',
    },
    {
      path: '*',
      redirect: '/',
    },
  ],
});

export default router;
